import MuiButton from './MuiButton';
import MuiFab from './MuiFab';
import MuiIconButton from './MuiIconButton';
import MuiInput from './MuiInput';
import MuiInputLabel from './MuiInputLabel';
import MuiMenuItem from './MuiMenuItem';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiSelect from './MuiSelect';
import MuiTab from './MuiTab';
import MuiTabs from './MuiTabs';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';

export default {
  MuiButton,
  MuiFab,
  MuiIconButton,
  MuiInput,
  MuiInputLabel,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiSelect,
  MuiTab,
  MuiTabs,
  MuiTableCell,
  MuiTableHead,
  MuiTypography,
};
